import { z } from 'zod';
import { TextItem } from './common';
export var WarningSign = TextItem;
export var WarningSigns = z.array(WarningSign).prefault([]);
